// extracted by mini-css-extract-plugin
export var wrapper = "Menu-module--wrapper--2ynki";
export var button = "Menu-module--button--1eIGA";
export var button__line = "Menu-module--button__line--WI9Nd";
export var open = "Menu-module--open--3YkFi";
export var menu = "Menu-module--menu--XvS32";
export var menu__list = "Menu-module--menu__list--28ZlF";
export var menu__item = "Menu-module--menu__item--2GE3q";
export var menu__item__link = "Menu-module--menu__item__link--1erEB";